// extracted by mini-css-extract-plugin
module.exports =  {"group":"OptionGroup-m4ZZ__group","full-width":"OptionGroup-tJEb__full-width","item":"OptionGroup-cQ96__item","item--active":"OptionGroup-VOui__item--active"};